export enum MemberRoleEnum {
  MEMBER = "MEMBER_ROLE_ENUM_MEMBER",
  ADMIN = "MEMBER_ROLE_ENUM_ADMIN",
  OWNER = "MEMBER_ROLE_ENUM_OWNER",
}

export enum ContractTypeEnum {
  ESIGN = "CONTRACT_TYPE_ENUM_ESIGN",
  DIRECT = "CONTRACT_TYPE_ENUM_DIRECT",
  ALL = "CONTRACT_TYPE_ENUM_ALL",
}

export enum EnterpriseRoleEnum {
  ADMIN = "admin",
  ALL = "all",
}
